/* eslint-disable  */
import React, { Component } from 'react'
import { useState } from 'react'
import getPreSignedURLForImageService from '../../Services/Queries/getPreSignedURLForImageService'
import ImageOptions from './ImageOptions'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import { heightPercentageToDP, widthPercentageToDP } from '../../Utils/ResponsiveScreen'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import MDEditor from '@uiw/react-md-editor'
import getImageTemplatesService from '../../Services/Queries/getImageTemplatesService'
import html2canvas from 'html2canvas'
import { KTColors } from '../Constants/KTColors'
import CreateMultiDynamicButtons from './CreateMultiDynamicButtons'
import ImageUpload from './ImageUpload'
import AwsConfig from '../../Config/AwsConfig'
import CompressContentImage from '../../Services/Mutations/compressContentImage'
import StoryUploadTypes from './StoryUploadTypes'
import SearchMediaLibrary from './MediaLibrary'

export default class StoryDetails extends Component {
	imageTemplateTypes = []
	constructor(props) {
		super(props)
		this.state = {
			cropImage: false,
			croppedImage: '',
			src: null,
			crop: {
				unit: '%',
				width: 30,
				aspect: 16 / 9,
			},
			storyTitle: '',
			storyCardDescription: '',
			selectedImage: '',
			storyCardImages: [],
			copyRight: false,
			copyRightText: '',
			shareImage: false,
			isEdited: false,
			subContentExpanded: false,
			expandedImage: null,
			expanded: true,
			files: [],
			imagePreviewUrl: [],
			youtubeID: '',
			selectedtype: 'Image',
			shortByteTemplateType: 'Small',
			urlType: 'Instagram',
			watchType: 'Off',
			instagramLink: '',
			youtubeLink: '',
			twitterLink: '',
			websiteLink: '',
			coverStoryVideoURL: '',
			storyVideoKey: '',
			deleteVideosFromS3: [],
			markDownEditor: false,
			imageTemplate: '',
			imageTemplateDescription: '',
			selectedImageTemplate: '',
			enableUploadImageTemplate: false,
			imageTemplateStyleType: 'default',
			enableUploadImage: false,
			selectedImageTemplateType: null,
			reviewRating: '',
			showRating: false,
			contentNewLinkDetails: [{}],
			isVertical: '',
			matchedLinkTexts: [],
			syncToWordpress: !(props.contentSelectedLangVal == 'En' || props.selectedContentType == 'ShortByte'),
			permalink: '',
			permalinkEdited: false,
			disableSyncToWordPress: false,
			featuredImageId: '',
			storyYoutubeImages: [],
			readMoreLink: '',
			isPermalinkNotInEnglish: false,
		}
	}

	handleSyncToWordpress = e => {
		const syncToWordpress = e.target.checked
		this.props.syncToWordpress && this.props.syncToWordpress(syncToWordpress)
		this.setState({ syncToWordpress })
		if (syncToWordpress && !this.state.permalinkEdited) {
			let permalink = this.state.storyTitle.trim()
			permalink = permalink.replace(/\s+/g, '-').toLowerCase()
			this.setState({ permalink }, () => {
				this.props.updateWordpressPermalink && this.props.updateWordpressPermalink(permalink)
			})
		}
	}

	handlePermalink = e => {
		let permalink = e.target.value

		let permalinkInvalid = false
		let permalinkCopy = ''

		for (let i = 0;i < permalink.length;i++) {
			const regExp = /^[0-9A-Za-z-_ ]+$/i
			const isMatch = regExp.test(permalink[i])
			if (isMatch) {
				permalinkCopy += permalink[i]
			} else {
				permalinkInvalid = true
			}
		}

		if (permalinkInvalid) {
			permalink = permalinkCopy
		}

		this.setState({ permalink, permalinkEdited: true, isPermalinkNotInEnglish: permalinkInvalid }, () => {
			permalink = permalink.replace(/\s+/g, '-').toLowerCase()
			this.props.updateWordpressPermalink && this.props.updateWordpressPermalink(permalink)
		})
	}

	handleTitle = e => {
		const title = e.target.value
		let permalink = title.trim()

		let permalinkInvalid = false
		let permalinkCopy = ''

		for (let i = 0;i < permalink.length;i++) {
			const regExp = /^[0-9A-Za-z-_ ]+$/i
			const isMatch = regExp.test(permalink[i])
			if (isMatch) {
				permalinkCopy += permalink[i]
			} else {
				permalinkInvalid = true
			}
		}

		if (permalinkInvalid) {
			permalink = permalinkCopy.trim().toString()
		}

		if (!this.state.permalinkEdited) {
			if (permalink !== '') {
				permalink = permalink.replace(/\s+/g, '-').toLowerCase()
				this.setState({ permalink })
				this.props.updateWordpressPermalink && this.props.updateWordpressPermalink(permalink)
			}
		}

		this.setState({ storyTitle: title, isEdited: true })
		this.props.updateInParent(`storyTitle_${this.props.contentSelectedLangVal}`, title.trim(), this.props.selectedContentType)
	}

	handleShortByteTemplateType = value => {
		const shortByteTemplateType = value
		this.setState({ shortByteTemplateType, isEdited: true })
		this.props.updateInParent('shortByteTemplateType', shortByteTemplateType, this.props.selectedContentType)
	}

	handleReviewRating = e => {
		const reviewRating = e.target.value

		this.setState({ reviewRating, isEdited: true })
		this.props.updateInParent('reviewRating', reviewRating, this.props.selectedContentType)
	}

	handleChangeShowRating = () => {
		this.setState({ showRating: !this.state.showRating, isEdited: true }, () => {
			this.props.updateInParent('showRating', this.state.showRating, this.props.selectedContentType)
		})
	}

	extractMDLabels = val => {
		const regexMdLinks = /\[([^\]]*)\]\(([^)]*)\)/g
		const updatedLinks = []
		if (val) {
			const matches = val.match(regexMdLinks)
			const singleMatch = /\[([^\[]+)\]\((.*)\)/
			matches?.map((item, index) => {
				const text = singleMatch.exec(matches[index])
				if (text) {
					updatedLinks.push(text[1])
				}
			})
		}

		return updatedLinks
	}

	handleMDCardDescription = val => {
		const description = this.props.selectedContentType == 'ShortByte' && this.state.shortByteTemplateType == 'Small' ? val.slice(0, 260) : val

		const mdMatchedLinks = this.extractMDLabels(description)
		this.setState({
			matchedLinkTexts: mdMatchedLinks,
			storyCardDescription: description,
			isEdited: true,
		})
		this.props.updateInParent(
			`storyCardDescription_${this.props.contentSelectedLangVal}`,
			description.trim(),
			this.props.selectedContentType,
		)
	}

	handleMarkDownEditor = () => {
		this.setState({ markDownEditor: !this.state.markDownEditor })
	}

	handleReadMoreLink = e => {
		const readMoreLink = e.target.value ? e.target.value.trim() : e.target.value
		this.setState({ readMoreLink })
		this.props.updateInParent('readMoreLink', readMoreLink, this.props.selectedContentType)
	}

	handleStoryCardImages = images => {
		const imagesArr = []
		images.filter(item => {
			const obj = {
				image: item.key ? item.key : item.image,
				copyRight: item.copyRight,
				copyRightText: item.copyRightText,
				shareImage: item.shareImage,
				position: item.position,

			}
			imagesArr.push(obj)
		})
		this.props.updateInParent('storyCardImages', imagesArr, this.props.selectedContentType)
		this.props.updateInParent('storyCardOriginalImages', images, this.props.selectedContentType)
		this.setState({ storyCardImages: images })
	}

	hastitleError = () => !this.state.storyTitle

	hasStoryCardImageError = () => !this.state.storyCardImages.length

	hasCardDescriptionError = () => !this.state.storyCardDescription

	toggleCopyRightSwitch = key => {
		const { storyCardImages } = this.state
		storyCardImages.filter(item => {
			if (item.key == key) {
				item.copyRight = !item.copyRight
			}
		})
		this.handleStoryCardImages(storyCardImages)
	}

	setFeaturedImageId = id => {
		this.setState({ featuredImageId: id })
		this.props.setFeaturedImageId(id)
	}

	handleCopyrightText = (key, text) => {
		const { storyCardImages } = this.state
		storyCardImages.filter(item => {
			const property = item.key ? 'key' : 'image'
			if (item[property] == key) {
				item.copyRightText = text
			}
		})
		this.handleStoryCardImages(storyCardImages)
	}

	handleCopyrightType = (item, copyrightPrefix) => {
		const key = item.key ? item.key : item.image

		const { storyCardImages } = this.state
		storyCardImages.filter(item => {
			const property = item.key ? 'key' : 'image'
			if (item[property] == key) {
				item.copyRightText = copyrightPrefix
			}
		})
		this.handleStoryCardImages(storyCardImages)
	}
	handleImageSize = (key, imageSize) => {
		const { storyCardImages } = this.state
		storyCardImages.filter((item) => {
			const property = item.key ? 'key' : 'image'
			if (item[property] == key) {
				item.position = imageSize
			}
		})
		this.handleStoryCardImages(storyCardImages)
	}

	handleImageSize = (key, imageSize) => {
		const { storyCardImages } = this.state
		storyCardImages.filter(item => {
			const property = item.key ? 'key' : 'image'
			if (item[property] == key) {
				item.position = imageSize
			}
		})
		this.handleStoryCardImages(storyCardImages)
	}

	toggleShareImageSwitch = item => {
		const key = item.key ? item.key : item.image
		const { storyCardImages } = this.state
		storyCardImages.filter(item => {
			const property = item.key ? 'key' : 'image'
			if (item[property] == key) {
				item.shareImage = !item.shareImage
			}
		})
		this.handleStoryCardImages(storyCardImages)
	}

	GetDate = () => (
		String(new Date().getFullYear()) +
		('0' + (new Date().getMonth() + 1)).slice(-2) +
		('0' + new Date().getDate()).slice(-2)
	)

	removeVideo = () => {
		const { deleteVideosFromS3 } = this.state
		deleteVideosFromS3.push(this.state.storyVideoKey)
		this.setState({
			deleteVideosFromS3,
			coverStoryVideoURL: '',
			storyVideoKey: '',
		})
		this.props.updateInParent('coverStoryVideoURL', '', this.props.selectedContentType)
	}

	handleUploadVideo = e => {
		const { files } = e.target
		const file = files[0]
		const reader = new FileReader()
		let videoName = file.name
		const index = videoName.lastIndexOf('.')
		if (index == 0) {
			videoName = 'dummy' + '' + videoName.replace(/[&\/\\#@,+()$~%'":*?<>{}]/g, '')
		}

		let videosName = ''
		if (index != -1) {
			videosName = videoName.substring(0, index).replace(/[&\/\\#@.,+()$~%'":*?<>{}]/g, '')
			videosName = videosName.length > 0 ? videosName : 'dummy'
		}

		videoName = videosName.replaceAll(' ', '') + '.mp4'
		reader.onloadend = async () => {
			const contentID = this.props.contentID.includes('cont#')
				? this.props.contentID.split('cont#')[1]
				: this.props.contentID
			const key = 'public/' + this.GetDate() + '/contents/' + contentID + '/Input/' + videoName
			const params = {
				key,
				mimeType: file.type,
			}
			const preSignedURLObject = await getPreSignedURLForImageService(params)
			const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
			const signedURL = signedURLObject.data.url
			try {
				const formData = new FormData()
				Object.keys(signedURLObject.data.fields).forEach(key => {
					formData.append(key, signedURLObject.data.fields[key])
				})
				// Actual file has to be appended last.
				formData.append('file', file)

				const response = await axios({
					method: 'post',
					url: signedURL,
					data: formData,
					headers: { 'Content-Type': 'multipart/form-data' },
				})
				if (response.status) {
					this.setState({ coverStoryVideoURL: reader.result, storyVideoKey: key })
					this.props.updateVideodetails({ contentVideoKey: key })
					this.props.updateInParent('coverStoryVideoURL', key, this.props.selectedContentType)
				}
			} catch (err) {
			}
		}

		reader.readAsDataURL(file)
	}

	handleImageChange = async e => {
		// const { files } = this.state
		// files.push(...e.target.files)
		e.preventDefault()
		const { files } = e.target
		for (let i = 0;i < files.length;i++) {
			const file = files[i]
			const reader = new FileReader()
			reader.onloadend = async () => {
				const file = files[i]
				const randomId = await uuidv4()
				const key = 'public/' + this.GetDate() + '/contents/' + randomId
				const params = {
					key,
					mimeType: file.type,
				}
				const preSignedURLObject = await getPreSignedURLForImageService(params)
				const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
				const signedURL = signedURLObject.data.url

				try {
					const formData = new FormData()
					Object.keys(signedURLObject.data.fields).forEach(key => {
						formData.append(key, signedURLObject.data.fields[key])
					})
					// Actual file has to be appended last.
					formData.append('file', file)

					const response = await axios({
						method: 'post',
						url: signedURL,
						data: formData,
						headers: { 'Content-Type': 'multipart/form-data' },
					})
					if (response.status) {
						const imageObj = {
							imageValue: reader.result,
							key,
							copyRight: false,
							copyRightText: '',
							shareImage: false,
						}
						const { storyCardImages } = this.state
						storyCardImages.push(imageObj)
						this.handleStoryCardImages(storyCardImages)
					}
				} catch (err) {
				}
			}

			reader.readAsDataURL(file)
		}
	}

	removeImage = imageIndex => {
		const images = this.state.storyCardImages
		images.splice(imageIndex, 1)
		if (this.state.storyYoutubeImages.length > 0) {
			this.state.storyYoutubeImages.splice(imageIndex, 1)
		}

		this.handleStoryCardImages(images)
		if (this.props.setFeaturedImageId) {
			this.setState({ featuredImageId: '' })
			this.props.setFeaturedImageId('')
		}
	}

	updatecontentLinkDetails = () => {
		const linkInput = {
			watchType: this.state.watchType,
			instagramLink: this.state.instagramLink,
			youtubeLink: this.state.youtubeLink,
			twitterLink: this.state.twitterLink,
			websiteLink: this.state.websiteLink,
		}

		if (this.state.watchType == 'watchVideo') {
			linkInput.urlType = this.state.urlType
		}

		if (this.state.watchType == 'visitWebsite') {
			linkInput.urlType = 'website'
		}

		this.props.updateInParent('contentLinkDetails', linkInput, this.props.selectedContentType)
	}

	updatecontentNewLinkDetails = linkInput => {
		linkInput.map(buttonObj => {
			if (buttonObj.category == 'socialMedia' && buttonObj.buttonPosition == 'default') {
				const input = {
					instagramLink: buttonObj.instagramLink,
					youtubeLink: buttonObj.youtubeLink,
					twitterLink: buttonObj.twitterLink,
					websiteLink: '',
					urlType: buttonObj.urlType?.replace('Link', ''),
					watchType: 'watchVideo',
				}
				this.props.updateInParent('contentLinkDetails', input, this.props.selectedContentType)
			} else {
				this.props.updateInParent('contentLinkDetails', {}, this.props.selectedContentType)
			}
		})
		const linkInputData = linkInput[0]
		if (linkInputData && linkInputData.instagramLink) {
			this.setState({ disableSyncToWordPress: false })
			this.props.disableSyncToWordPress(false)
		} else if (linkInputData && linkInputData.youtubeLink) {
			this.setState({ disableSyncToWordPress: false })
			this.props.disableSyncToWordPress(false)
		} else if (linkInputData && linkInputData.twitterLink) {
			this.setState({ disableSyncToWordPress: false })
			this.props.disableSyncToWordPress(false)
		} else if (linkInputData && linkInputData.urlType) {
			this.setState({ disableSyncToWordPress: true })
			this.props.disableSyncToWordPress(true)
		}

		this.props.updateInParent('contentNewLinkDetails', linkInput, this.props.selectedContentType)
	}

	handleWatchType = value => {
		if (this.state.watchType != value) {
			this.setState(
				{
					watchType: value,
					urlType: 'Instagram',
					instagramLink: '',
					youtubeLink: '',
					twitterLink: '',
					websiteLink: '',
				},
				() => {
					this.updatecontentLinkDetails()
				},
			)
		}
	}

	updateStateData = () => {
		const { syncToWordpressValue, duplicateContent } = this.props
		const {
			storyCardImages,
			storyYoutubeImages,
			contentLinkDetails,
			contentNewLinkDetails,
			coverStoryVideoURL,
			youtubeID,
			showRating,
			reviewRating,
			imageTemplate,
			imageTemplateDescription,
			readMoreLink,
			youtubeVideoOrientation, shortByteTemplateType,
		} = this.props.storyDetails
		const storyTitle = duplicateContent ? '' : this.props.storyDetails[
			`storyTitle_${this.props.contentSelectedLangVal}`
		]
		const storyCardDescription = duplicateContent ? '' : this.props.storyDetails[
			`storyCardDescription_${this.props.contentSelectedLangVal}`
		]
		const selectedtype = youtubeID
			? 'youtubeID'
			: storyCardImages && storyCardImages.length > 0 && !imageTemplate
				? 'Image'
				: coverStoryVideoURL != ''
					? 'Video'
					: imageTemplate != ''
						? 'imageTemplate'
						: 'Image'
		const selectedImageTemplatePath = imageTemplateDescription
			? storyCardImages && storyCardImages[0]?.image
			: ''
		const wordPressInfoExists =
			this.props.wordPressInfo && Object.keys(this.props.wordPressInfo).length > 0
		this.setState({
			permalink: !this.props.duplicateContent && wordPressInfoExists ? this.props.wordPressInfo.wordPressPermaLink : '',
			featuredImageId:
				this.props.wordPressInfo && Object.keys(this.props.wordPressInfo).length > 0
					? this.props.wordPressInfo.wordPressMediaID
						? parseInt(this.props.wordPressInfo.wordPressMediaID)
						: ''
					: '',
			syncToWordpress: !this.props.duplicateContent && syncToWordpressValue && this.props.selectedContentType !== 'ShortByte' ? true : !(this.props.contentSelectedLangVal == 'En' || this.props.selectedContentType == 'ShortByte'),
			selectedtype,
			storyTitle,
			storyCardDescription,
			storyYoutubeImages: storyYoutubeImages ? storyYoutubeImages : [],
			storyCardImages:
				storyCardImages && storyCardImages.length > 0
					? storyCardImages
					: storyYoutubeImages
						? storyYoutubeImages
						: [],
			coverStoryVideoURL: coverStoryVideoURL ? coverStoryVideoURL : '',
			youtubeID: youtubeID ? youtubeID : '',
			watchType: contentLinkDetails ? contentLinkDetails.watchType : 'Off',
			urlType: contentLinkDetails ? contentLinkDetails.urlType : 'Instagram',
			instagramLink: contentLinkDetails ? contentLinkDetails.instagramLink : '',
			youtubeLink: contentLinkDetails ? contentLinkDetails.youtubeLink : '',
			twitterLink: contentLinkDetails ? contentLinkDetails.twitterLink : '',
			websiteLink: contentLinkDetails ? contentLinkDetails.websiteLink : '',
			showRating: showRating ? showRating : false,
			reviewRating: reviewRating ? reviewRating : '',
			imageTemplate: imageTemplate ? imageTemplate : '',
			imageTemplateDescription: imageTemplateDescription ? imageTemplateDescription : '',
			selectedImageTemplate: selectedImageTemplatePath,
			imageTemplateStyleType: imageTemplateDescription ? 'custom' : 'default',
			contentNewLinkDetails,
			readMoreLink: readMoreLink ? readMoreLink : '',
			isVertical: youtubeVideoOrientation ? youtubeVideoOrientation : '',
			shortByteTemplateType: shortByteTemplateType ? shortByteTemplateType : 'Small',
		})
	}

	async componentDidMount() {
		const { editContent } = this.props
		const data = await getImageTemplatesService({ limit: 10, imageTemplateContentType: 'Story' })
		if (data != undefined && data.length > 0) {
			this.imageTemplateTypes = data
		}

		if (!editContent) {
			if (this.props.contentSelectedLangVal == 'Te' && this.props.selectedContentType !== 'ShortByte') {
				this.setState({ syncToWordpress: true })
			} else {
				this.setState({ syncToWordpress: false })
			}
		}

		if (editContent && this.props.storyDetails && Object.keys(this.props.storyDetails).length > 0) {
			this.updateStateData()
		}
	}

	componentDidUpdate = (prevProps, prevState) => {
		const { syncToWordpressValue } = this.props
		if (prevProps.contentSelectedLangVal != this.props.contentSelectedLangVal || this.props.selectedContentType != prevProps.selectedContentType) {
			const { editContent } = this.props
			if (!editContent) {
				if (this.props.contentSelectedLangVal == 'Te' && this.props.selectedContentType != 'ShortByte') {
					this.setState({ syncToWordpress: true })
				} else {
					this.setState({ syncToWordpress: false })
				}
			}

			if (
				editContent &&
				this.props.storyDetails &&
				Object.keys(this.props.storyDetails).length > 0
			) {
				this.updateStateData()
			}
		} else if (
			this.props.wordPressInfo &&
			Object.keys(prevProps.wordPressInfo).length != Object.keys(this.props.wordPressInfo).length
		) {
			const wordPressInfoExists =
				this.props.wordPressInfo && Object.keys(this.props.wordPressInfo).length > 0

			this.setState({
				featuredImageId:
					this.props.wordPressInfo && Object.keys(this.props.wordPressInfo).length > 0
						? this.props.wordPressInfo.wordPressMediaID
							? parseInt(this.props.wordPressInfo.wordPressMediaID)
							: ''
						: '',

				syncToWordpress:
					Boolean(syncToWordpressValue),
				permalink: !this.props.duplicateContent && wordPressInfoExists ? this.props.wordPressInfo.wordPressPermaLink : '',

			})
		}
	}

	handleType = selectedtype => {
		this.setState({
			youtubeID: '',
			coverStoryVideoURL: '',
			storyCardImages: [],
			selectedtype,
			imageTemplateKey: '',
			imageTemplate: '',
		})
		this.removeSelectedImage()

		this.props.updateInParent('youtubeID', '', this.props.selectedContentType)
		this.props.updateInParent('coverStoryVideoURL', '', this.props.selectedContentType)
		this.props.updateInParent('storyCardImages', [], this.props.selectedContentType)
	}

	handleYoutubeID = async e => {
		const youtubeID = e.target.value.trim()
		this.setState({ youtubeID })
		this.props.updateInParent('youtubeID', youtubeID, this.props.selectedContentType)
		// this.props.updateInParent('youtubeVideoOrientation', youtubeVideoOrientation, this.props.selectedContentType)
	}

	handleYoutubeVideoType = value => {
		this.setState({ isVertical: value })
		const youtubeVideoOrientation = value

		this.props.updateInParent('youtubeVideoOrientation', youtubeVideoOrientation, this.props.selectedContentType)
	}

	handleimageTemplateDescription = e => {
		const imageTemplateDescription = e.target.value
		this.setState({ imageTemplateDescription })
	}

	handleYoutubeIDError = () => !this.state.youtubeID != ''

	handleImageTemplateError = () => !this.state.imageTemplate != ''

	handleUrlType = value => {
		this.setState({ urlType: value, instagramLink: '', youtubeLink: '', twitterLink: '' }, () => {
			this.updatecontentLinkDetails()
		})
	}

	handleinstagramLink = e => {
		const link = e.target.value.trim()

		this.setState({ instagramLink: link }, () => {
			this.updatecontentLinkDetails()
		})
	}

	handleinstagramLinkError = () => !this.state.instagramLink != ''

	handleyoutubeLink = e => {
		const link = e.target.value.trim()

		this.setState({ youtubeLink: link }, () => {
			this.updatecontentLinkDetails()
		})
	}

	handleyoutubeLinkError = () => !this.state.youtubeLink != ''

	handletwitterLink = e => {
		const link = e.target.value.trim()

		this.setState({ twitterLink: link }, () => {
			this.updatecontentLinkDetails()
		})
	}

	handletwitterLinkError = () => !this.state.twitterLink != ''

	handlewebsiteLink = e => {
		const link = e.target.value.trim()
		this.setState({ websiteLink: link }, () => {
			this.updatecontentLinkDetails()
		})
	}

	handlewebsiteLinkError = () => !this.state.websiteLink != ''

	pushImageObj = async (imageObj, uploadFromLibrary, selectedImages) => {
		const { storyCardImages } = this.state
		storyCardImages.push(imageObj)
		const input = {
			imagePath: imageObj.key,
		}

		this.handleStoryCardImages(storyCardImages)
		if (uploadFromLibrary == undefined && input != undefined && input != null && input.imagePath != null && input.imagePath != undefined && input.imagePath != '') {
			const response = await CompressContentImage(input)
		}
	}

	onSelectFile = e => {
		if (e.target.files && e.target.files.length > 0) {
			const reader = new FileReader()
			reader.addEventListener('load', () => {
				this.setState({
					src: reader.result,
				})
			})
			reader.readAsDataURL(e.target.files[0])
			this.setState({
				cropImage: false,
				storyCardImages: [],
				selectedImage: e.target.files[0],
				// crop: false,
				croppedImageUrl: '',
				croppedImage: '',
			})
		}
	}

	// If you setState the crop in here you should return false.
	onImageLoaded = image => {
		this.imageRef = image
	}

	onCropComplete = crop => {
		this.makeClientCrop(crop)
	}

	onCropChange = (crop, percentCrop) => {
		// You could also use percentCrop:
		// this.setState({ crop: percentCrop });
		this.setState({ crop })
	}

	async makeClientCrop(crop) {
		if (this.imageRef && crop.width && crop.height) {
			const croppedImageUrl = await this.getCroppedImg(this.imageRef, crop, 'newFile.jpeg')
			this.setState({ croppedImageUrl })
		}
	}

	removeSelectedImage = () => {
		this.setState({
			cropImage: false,
			storyCardImages: [],
			src: null,
			crop: {
				unit: '%',
				width: 30,
				aspect: 16 / 9,
			},
			croppedImageUrl: '',
			croppedImage: '',
		})
		this.props.updateInParent('storyCardImages', [], this.props.selectedContentType)
		this.props.updateInParent('storyCardOriginalImages', [], this.props.selectedContentType)
	}

	uploadSelectedImage = async crop => {
		const randomId = await uuidv4()
		const key = 'public/' + this.GetDate() + '/contents/' + randomId
		const params = {
			key,
			mimeType: this.state.selectedImage.type,
		}
		const preSignedURLObject = await getPreSignedURLForImageService(params)
		const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
		const signedURL = signedURLObject.data.url
		try {
			const formData = new FormData()
			Object.keys(signedURLObject.data.fields).forEach(key => {
				formData.append(key, signedURLObject.data.fields[key])
			})
			// Actual file has to be appended last.
			if (crop) {
				formData.append('file', this.state.croppedImage)
			} else {
				formData.append('file', this.state.selectedImage)
			}

			const response = await axios({
				method: 'post',
				url: signedURL,
				data: formData,
				headers: { 'Content-Type': 'multipart/form-data' },
			})
			if (response.status) {
				const imageObj = {
					imageValue: this.state.croppedImageUrl ? this.state.croppedImageUrl : this.state.src,
					key,
					copyRight: false,
					copyRightText: '',
					shareImage: false,
				}
				const { storyCardImages } = this.state
				storyCardImages.push(imageObj)
				this.handleStoryCardImages(storyCardImages)
			}
		} catch (err) {
		}
	}

	getCroppedImg(image, crop, fileName) {
		const canvas = document.createElement('canvas')
		const pixelRatio = window.devicePixelRatio
		const scaleX = image.naturalWidth / image.width
		const scaleY = image.naturalHeight / image.height
		const ctx = canvas.getContext('2d')

		canvas.width = crop.width * pixelRatio * scaleX
		canvas.height = crop.height * pixelRatio * scaleY

		ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0)
		ctx.imageSmoothingQuality = 'high'

		ctx.drawImage(
			image,
			crop.x * scaleX,
			crop.y * scaleY,
			crop.width * scaleX,
			crop.height * scaleY,
			0,
			0,
			crop.width * scaleX,
			crop.height * scaleY,
		)

		return new Promise((resolve, reject) => {
			canvas.toBlob(
				blob => {
					if (!blob) {
						// reject(new Error('Canvas is empty'));
						return
					}

					blob.name = fileName
					window.URL.revokeObjectURL(this.fileUrl)
					this.fileUrl = window.URL.createObjectURL(blob)
					this.setState({ croppedImage: blob })
					resolve(this.fileUrl)
				},
				'image/jpeg',
				1,
			)
		})
	}

	handleTemplateClick = type => {
		this.setState(
			{
				imageTemplate: type.imageTemplateHeading,
				selectedImageTemplate: type.imageTemplatePath,
				selectedImageTemplateType: type,
				storyCardImages: [],
			},
			() => {
				let imageTemplateKey = ''
				if (type.imageTemplatePath && type.imageTemplatePath.startsWith('https')) {
					const fullPath = type.imageTemplatePath.split('://')[1]
					imageTemplateKey = fullPath.substring(fullPath.indexOf('/') + 1)
				} else {
					imageTemplateKey = type.imageTemplatePath
				}

				this.props.updateInParent('imageTemplate', this.state.imageTemplate, this.props.selectedContentType)
				this.props.updateInParent('imageTemplateKey', imageTemplateKey, this.props.selectedContentType)
				const imageObj = {
					imageValue: type.imageTemplatePath,
					key: imageTemplateKey,
					copyRight: false,
					copyRightText: '',
					shareImage: false,
				}
				const { storyCardImages } = this.state
				storyCardImages.push(imageObj)
				this.handleStoryCardImages(storyCardImages)
			},
		)
	}

	PrintDiv = templateTitle => {
		html2canvas(document.getElementById('generateTemplateImage'), {
			useCORS: true,
		}).then(canvas => {
			const imageURL = canvas.toDataURL('image/png')
			const a = document.createElement('a')
			a.href = imageURL
			a.download = templateTitle
			a.click()
		})
	}

	render() {
		const { data } = this.props
		const {
			storyTitle,
			coverStoryVideoURL,
			selectedtype,
			storyCardImages,
			youtubeID,
			permalink,
			syncToWordpress,
			imageTemplateDescription,
			isVertical,
			storyYoutubeImages,
			shortByteTemplateType,
		} = this.state
		const images =
			storyCardImages && storyCardImages.length > 0 ? storyCardImages : storyYoutubeImages
		return (
			<div className='row col-md-10'>
				<details>
					<summary>{this.props.selectedContentType == 'Story' ? 'Story Details' : 'Short Byte Details'}</summary>
					<div className='content'>
						{!this.state.disableSyncToWordPress ? (
							<div>
								<input
									disabled={this.state.disableSyncToWordPress}
									type='checkbox'
									onChange={e => {
										this.handleSyncToWordpress(e)
									}}
									checked={syncToWordpress}
								/>
								<label style={{ marginLeft: widthPercentageToDP('1') }}>Sync To Website</label>
							</div>
						) : null}
						<div className='row'>
							<text htmlFor='text'>Title :</text>
							<textarea
								type='text'
								onChange={value => {
									this.handleTitle(value)
								}}
								value={storyTitle}
								placeholder='Please Enter  Title'
							></textarea>
							{this.hastitleError() ? (
								<text htmlFor='text' style={{ color: 'red', fontSize: 10 }}>
									Title Cannot Be Empty
								</text>
							) : null}
						</div>
						{this.state.syncToWordpress ? (
							<div className='row'>
								<text htmlFor='text'>Permalink :</text>
								<textarea
									type='text'
									onChange={value => {
										this.handlePermalink(value)
									}}
									value={permalink}
									placeholder='Please Enter  Permalink'
								></textarea>
								{this.state.isPermalinkNotInEnglish ? (
									<text htmlFor='text' style={{ color: 'red', fontSize: 10 }}>
										Invalid Character or not in English
									</text>
								) : null}
							</div>
						) : null}
						{this.props.selectedContentType == 'Story' &&
							<div className='col-md-12' style={{ marginTop: 5, marginBottom: 5, marginLeft: -5 }}>
								<input
									type='checkbox'
									onChange={this.handleMarkDownEditor}
									checked={this.state.markDownEditor}
									style={{ marginRight: 5, marginLeft: 0 }}
								></input>
								<text htmlFor='text'>Markdown Description</text>
							</div>
						}
						{this.props.selectedContentType == 'ShortByte' &&

							<div className='row mb-2 mt-2'>
								<label htmlFor='text'>Choose Description Template Type</label>
								<div style={{ marginRight: 10 }} className='col-md-3'>
									<input
										value={shortByteTemplateType}
										checked={shortByteTemplateType == 'Small'}
										type='radio'
										onChange={() => {
											this.handleShortByteTemplateType('Small')
										}}
									></input>
									<text htmlFor={'Small'}>{'Small'}</text>
								</div>
								<div style={{ marginRight: 10 }} className='col-md-3'>
									<input
										value={shortByteTemplateType}
										checked={shortByteTemplateType == 'Medium'}
										type='radio'
										onChange={() => {
											this.handleShortByteTemplateType('Medium')
										}}
									></input>
									<text htmlFor={'Medium'}>{'Medium'}</text>
								</div>
								<div style={{ marginRight: 10 }} className='col-md-3'>
									<input
										value={shortByteTemplateType}
										checked={shortByteTemplateType == 'Large'}
										type='radio'
										onChange={() => {
											this.handleShortByteTemplateType('Large')
										}}
									></input>
									<text htmlFor={'Large'}>{'Large'}</text>
								</div>
							</div>
						}

						<div className='row'>
							<text htmlFor='text'>Read More Link :</text>
							<input
								type='text'
								onChange={value => {
									this.handleReadMoreLink(value)
								}}
								value={this.state.readMoreLink}
								placeholder='Please Enter  Read More Link'
							></input>
						</div>
						<div className='row'>
							<text htmlFor='text'>Card Description :</text>
							<MDEditor
								preview={this.state.markDownEditor ? 'live' : 'edit'}
								value={this.state.storyCardDescription}
								onChange={value => this.handleMDCardDescription(value)}
							/>
							{this.hasCardDescriptionError() ? (
								<text htmlFor='text' style={{ color: 'red', fontSize: 10 }}>
									Description Cannot Be Empty
								</text>
							) : null}
						</div>

						{this.props.selectedContentType == 'Story' &&
							<div>
								<input
									type='checkbox'
									onChange={() => this.handleChangeShowRating()}
									checked={this.state.showRating}
								/>
								<label style={{ marginLeft: widthPercentageToDP('1') }}>Show Review Rating</label>
							</div>
						}
						{this.state.showRating ? (
							<div>
								<text htmlFor='text'>Review Rating: </text>
								<div>
									<input
										type='text'
										onChange={value => {
											this.handleReviewRating(value)
										}}
										value={this.state.reviewRating}
										placeholder='Please Enter Review Rating'
									></input>
								</div>
							</div>
						) : null}
						<CreateMultiDynamicButtons
							selectedContentType={this.props.selectedContentType}
							editContent={this.props.editContent}
							contentNewLinkDetails={this.state.contentNewLinkDetails}
							updatecontentNewLinkDetails={this.updatecontentNewLinkDetails}
							markdownLinkLables={this.state.matchedLinkTexts}
						/>
						<StoryUploadTypes
							selectedContentType={this.props.selectedContentType}
							handleType={this.handleType} selectedtype={this.state.selectedtype} />
						{selectedtype == 'Image' ? (
							<div>
								<div className='row'>
									<text htmlFor='text'>Upload Story Card :</text>
									<p htmlFor='text' style={{ color: 'red', fontSize: 10 }}>
										(Only JPG and JPEG images are allowed)
									</p>
									<div className='App'>
										{/* <ImageUpload
											pushImageObj={this.pushImageObj}
											setFeaturedImageId={this.setFeaturedImageId}
											multiImages={true}
											circularCrop={false}
										/> */}
										<SearchMediaLibrary
											selectedContentType={this.props.selectedContentType}
											shortByteTemplateType={this.state.shortByteTemplateType}
											pushImageObj={this.pushImageObj}
											setFeaturedImageId={this.setFeaturedImageId}
											multiImages={true}
											circularCrop={false}
											selectedMedia={images} />
										{images.length > 0 ? null : (
											<text htmlFor='text' style={{ color: 'red', fontSize: 10 }}>
												Please upload an image
											</text>
										)}

										{

										}
										{storyCardImages?.map((item, index) => {
											const { copyRightText, copyRight, shareImage, imageValue, image } = item
											const cdnurl = AwsConfig.cdn_url
											let finalImage = image ? image : ''
											if (finalImage && !finalImage.includes(cdnurl)) {
												finalImage = cdnurl + image
											}

											const key = item.key ? item.key : item.image
											const srcImg = image ? finalImage : imageValue
											return (
												<div className='imagesContainer' key={index}>
													<img style={{ maxWidth: '100%' }} src={srcImg} />
													<button onClick={() => this.removeImage(index)}>Remove Image</button>
													<div className='imgPreview'>
														<ImageOptions
															srcImg={srcImg}
															syncToWordpress={this.state.syncToWordpress}
															item={item}
															copyRight={copyRight}
															copyRightText={copyRightText}
															toggleCopyRightSwitch={item => this.toggleCopyRightSwitch(item)}
															handleCopyrightType={(item, copyrightPrefix) =>
																this.handleCopyrightType(item, copyrightPrefix)
															}
															handleImageSize={(item, imageSize) =>
																this.handleImageSize(item, imageSize)
															}
															handleCopyrightText={this.handleCopyrightText}
															shareImage={shareImage}
															toggleShareImageSwitch={item => this.toggleShareImageSwitch(item)}
														/>

													</div>
												</div>
											)
										})}
									</div>
								</div>
							</div>
						) : null}
						{selectedtype == 'Video' ? (
							<div>
								<div className='row'>
									<text htmlFor='text'>Upload Video :</text>

									<input
										className='fileInput'
										type='file'
										accept='video/mp4'
										onChange={e => this.handleUploadVideo(e)}
									/>
									{!coverStoryVideoURL ? (
										<text htmlFor='text' style={{ color: 'red', fontSize: 10 }}>
											Please Upload Video
										</text>
									) : null}
								</div>
							</div>
						) : null}
						{coverStoryVideoURL ? (
							<div>
								<video width='320' height='240' controls>
									<source src={coverStoryVideoURL} type='video/mp4' />
								</video>
								<button onClick={() => this.removeVideo()}>Remove</button>
							</div>
						) : null}
						{selectedtype == 'youtubeID' ? (
							<div>
								<text htmlFor='text'>Youtube ID :</text>
								<textarea
									type='text'
									onChange={value => {
										this.handleYoutubeID(value)
									}}
									value={youtubeID}
									placeholder='Please Enter Youtube ID'
								></textarea>
								{this.handleYoutubeIDError() ? (
									<text htmlFor='text' style={{ color: 'red', fontSize: 10 }}>
										Youtube ID Cannot Be Empty
									</text>
								) : null}

								{selectedtype == 'youtubeID' && youtubeID != '' ? (
									<div>
										<div style={{ marginRight: 10 }}>
											<input
												value={isVertical}
												type='radio'
												checked={isVertical == 'vertical'}
												onChange={() => {
													this.handleYoutubeVideoType('vertical')
												}}
											></input>
											<text htmlFor={'Vertical'}>{'Vertical'}</text>
										</div>
										<div style={{ marginRight: 10 }}>
											<input
												value={!isVertical}
												type='radio'
												checked={isVertical == 'horizontal'}
												onChange={() => {
													this.handleYoutubeVideoType('horizontal')
												}}
											></input>
											<text htmlFor={'Horizontal'}>{'Horizontal'}</text>
										</div>
									</div>
								) : null}
								{isVertical == '' && !isVertical ? (
									<text htmlFor='text' style={{ color: 'red', fontSize: 10 }}>
										Youtube Video Orientation Cannot be Empty
									</text>
								) : null}
								{this.state.syncToWordpress ? (
									<div className='row'>
										<text htmlFor='text'>Featured Image For Website</text>
										<div className='App'>
											<ImageUpload
												selectedContentType={this.props.selectedContentType}
												shortByteTemplateType={this.state.shortByteTemplateType}
												pushImageObj={this.pushImageObj}
												setFeaturedImageId={this.setFeaturedImageId}
												multiImages={false}
												circularCrop={false}
												isYoutube={true}
											/>
											{images.length > 0 ? null : (
												<text htmlFor='text' style={{ color: 'red', fontSize: 10 }}>
													Please upload an image
												</text>
											)}
											{images?.map((item, index) => {
												const {
													copyRightText,
													copyRight,
													shareImage,
													key,
													imageValue,
													image,
												} = item

												const cdnurl = AwsConfig.cdn_url
												let finalImage = image ? image : ''
												if (finalImage && !finalImage.includes(cdnurl)) {
													finalImage = cdnurl + image
												}

												const srcImg = image ? finalImage : imageValue
												return (
													<div className='imagesContainer' key={index}>
														<img style={{ maxWidth: '100%' }} src={srcImg} />
														<button onClick={() => this.removeImage(index)}>Remove Image</button>
														<div className='imgPreview'>
															<ImageOptions
																syncToWordpress={this.state.syncToWordpress}
																item={item}
																copyRight={copyRight}
																copyRightText={copyRightText}
																toggleCopyRightSwitch={key => this.toggleCopyRightSwitch(key)}
																handleCopyrightType={(key, copyrightPrefix) =>
																	this.handleCopyrightType(key, copyrightPrefix)
																}
																handleCopyrightText={this.handleCopyrightText}
																shareImage={shareImage}
																toggleShareImageSwitch={key => this.toggleShareImageSwitch(key)}
															/>
														</div>
													</div>
												)
											})}
										</div>
									</div>
								) : null}
							</div>
						) : null}
						{selectedtype == 'imageTemplate' && this.imageTemplateTypes.length > 0 ? (
							<div>
								<div>
									<text style={{ fontWeight: 'bold' }}>Image Template types:</text>
									<div style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
										{this.imageTemplateTypes.map((type, typeIndex) => (
											<div key={typeIndex} style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
												<input
													value={type.imageTemplateHeading}
													type='radio'
													checked={this.state.imageTemplate == type.imageTemplateHeading}
													onClick={() => {
														this.handleTemplateClick(type)
													}}
												></input>
												<text htmlFor='text'>{type.imageTemplateHeading}</text>
												<img
													width={widthPercentageToDP('10')}
													height={heightPercentageToDP('5')}
													src={type.imageTemplatePath}
												/>
											</div>
										))}
									</div>
									<div>
										{this.state.selectedImageTemplate && (
											<div>
												<div style={{ marginTop: 5, marginBottom: 5 }}>
													<button
														style={{
															backgroundColor:
																this.state.imageTemplateStyleType == 'default'
																	? '#0066ff'
																	: 'transparent',
														}}
														onClick={() => {
															this.setState({ imageTemplateStyleType: 'default' })
															this.handleTemplateClick(this.state.selectedImageTemplateType)
														}}
													>
														Without Customise
													</button>
													<button
														style={{
															backgroundColor:
																this.state.imageTemplateStyleType == 'custom'
																	? '#0066ff'
																	: 'transparent',
														}}
														onClick={() => {
															this.setState({ imageTemplateStyleType: 'custom' }, () => {
																this.props.updateInParent('storyCardImages', [], this.props.selectedContentType)
																this.props.updateInParent('storyCardOriginalImages', [], this.props.selectedContentType)
															})
														}}
													>
														Customise
													</button>
												</div>
												{this.state.imageTemplateStyleType == 'default' &&
													this.state.selectedImageTemplate != '' && (
														<img
															width={widthPercentageToDP('100')}
															height={heightPercentageToDP('35')}
															src={this.state.selectedImageTemplate}
														/>
													)}
											</div>
										)}
									</div>
									{this.handleImageTemplateError() ? (
										<text htmlFor='text' style={{ color: 'red', fontSize: 10 }}>
											ImageTemplate Cannot Be Empty
										</text>
									) : null}
								</div>
								{this.state.imageTemplateStyleType == 'custom' && (
									<div>
										<div className='row'>
											<div>
												<text htmlFor='text'>ImageTemplate Description : </text>
											</div>
											<textarea
												type='text'
												onChange={value => {
													this.handleimageTemplateDescription(value)
												}}
												value={imageTemplateDescription}
												placeholder='Please Enter imageTemplate Description'
											></textarea>
										</div>
										<div>
											{this.state.imageTemplateDescription && (
												<button
													onClick={() => {
														this.setState({ enableUploadImageTemplate: true })
													}}
												>
													View Template Thumbnail
												</button>
											)}
											{this.state.imageTemplateDescription && (
												<button
													onClick={() => {
														this.PrintDiv(this.state.imageTemplateDescription)
													}}
												>
													Download Template Thumbnail
												</button>
											)}
										</div>
										<div>
											{this.state.enableUploadImageTemplate ? (
												<div
													style={{
														height: heightPercentageToDP('35%'),
														width: widthPercentageToDP('99%'),
														position: 'relative',
													}}
													id='generateTemplateImage'
												>
													<div
														style={{
															position: 'absolute',
															top: heightPercentageToDP('10'),
															padding: widthPercentageToDP('5%'),
															width: widthPercentageToDP('100'),
															alignItems: 'center',
															textAlign: 'center',
															justifyContent: 'center',
															alignSelf: 'center',
															alignContent: 'center',
														}}
													>
														<text
															style={{
																textAlign: 'center',
																fontSize: heightPercentageToDP('2.6'),
																color: KTColors.white,
																flexWrap: 'wrap',
															}}
														>
															{imageTemplateDescription}
														</text>
													</div>
													<img
														src={this.state.selectedImageTemplate}
														alt='User Avatar'
														style={{
															height: heightPercentageToDP('35%'),
															width: widthPercentageToDP('100%'),
														}}
													/>
												</div>
											) : null}
										</div>
										{this.state.imageTemplateDescription && (
											<div>
												<input
													type='file'
													accept='.jpg,.jpeg'
													onChange={e => {
														this.setState({ enableUploadImage: true })
														this.onSelectFile(e)
													}}
												/>
												<p htmlFor='text' style={{ color: 'red', fontSize: 10 }}>
													(Only JPG and JPEG images are allowed)
												</p>

												{this.state.enableUploadImage && (
													<button
														onClick={() => {
															this.props.updateInParent(
																'imageTemplateDescription',
																this.state.imageTemplateDescription,
																this.props.selectedContentType,
															)
															this.uploadSelectedImage(false)
														}}
													>
														Upload Template with Description
													</button>
												)}
											</div>
										)}
									</div>
								)}
							</div>
						) : null}
					</div>
				</details >

			</div >
		)
	}
}
